import UseCase from "./marketing/UseCase";

export default function UseCaseRecruiters() {
  return (
    <UseCase
      path="/for/recruiters"
      seoTitle="NFC business cards for recruiters — WhoBrew"
      seoDescription="A digital business card for recruiters at career fairs, on LinkedIn, and at industry events. One link with your live ATS, open roles, and intake form."
      eyebrow="For recruiters"
      headline="Stop running out of paper cards at every career fair."
      italicWord="every"
      subhead="One card with your live ATS, your open roles, your intake form, and your calendar. Update it from your phone between candidates. Never reprint, never run dry."
      preview={{ name: "Sean Thomas", title: "Senior Technical Recruiter", handle: "seanthomas" }}
      linkExamples={[
        { label: "Open roles" },
        { label: "Greenhouse" },
        { label: "Lever" },
        { label: "LinkedIn jobs" },
        { label: "Calendly" },
        { label: "Resume PDF" },
        { label: "Careers page" },
        { label: "Candidate intake form" },
      ]}
      features={[
        {
          title: "A live open-roles link.",
          body: "Candidates open the link and see your live ATS, careers page, or LinkedIn jobs. Always current, never out of date by the time the conversation ends.",
        },
        {
          title: "Per-event analytics.",
          body: "Tag a card with the event name. See which career fairs actually drove conversations. Per-link click tracking is included on every plan.",
        },
        {
          title: "Lead capture from the card itself.",
          body: "Candidates leave their name, email, and a short note from the contact form on your public card. It lands in your Leads tab, source-tagged, ready for follow-up.",
        },
      ]}
      steps={[
        {
          title: "Build the card with your roles and ATS.",
          body: "Add your open roles, your Greenhouse or Lever public board, your Calendly, and your LinkedIn. Two minutes.",
        },
        {
          title: "Print the QR for the booth, hand out the NFC card to every candidate.",
          body: "Generate a print-ready QR code for your career-fair table. Order an NFC card to hand to candidates who want to follow up later.",
        },
        {
          title: "Check Insights after the event.",
          body: "Filter by date, see who visited, what they clicked, and how many saved you. Use that to decide which fairs to attend next quarter.",
        },
      ]}
      faq={[
        {
          q: "Does my company need to approve this?",
          a: "WhoBrew is yours to set up and use independently. You link to your company's external careers page. No IT, legal, or marketing approval needed for the card itself, since the data on it is the same data you already share publicly on LinkedIn or your business card.",
        },
        {
          q: "Can I use this at an external career fair, not my company's event?",
          a: "Yes. The card belongs to you. You can share it anywhere — university fairs, industry conferences, LinkedIn DMs, post-event follow-ups. The card stays with you when you change firms.",
        },
        {
          q: "What happens when I change firms?",
          a: "You update your card once and every share you have ever made — past or future — points to your new info. The link itself stays the same forever. Your old paper cards are dead the day you change firms; your WhoBrew card isn't.",
        },
        {
          q: "Can candidates leave me their contact info from the card?",
          a: "Yes. The Contact me button on your public card lets candidates send you their name, email, and a short note. It lands in your Leads tab, source-tagged so you can see which event drove which lead.",
        },
        {
          q: "Does my whole team need separate accounts?",
          a: "Each recruiter gets their own card and account. Centralized team management is in WhoBrew for Teams, with admin controls and shared branding. Most teams of five or more recruiters move to Teams within their first quarter.",
        },
      ]}
    />
  );
}
